<template>
    <div>
        <section class="cheap-flights">
            <div class="container">
                <p class="title">
                    Cheap flights offers.
                </p>
                <p>Save up to <strong>30-70%*</strong> OFF on business and first-class</p>
                <p>tickets when traveling internationally.</p>
                <div class="owl-carousel">
                    <VueSlickCarousel
                        :arrows="true"
                        :centerMode="true"
                        :adaptiveHeight="true"
                        :slidesToShow="3"
                        :centerPadding="'0'"
                        :accessibility="false"
                        :variableWidth="true"
                        :draggable="false"
                        :responsive="responsive"
                    >
                        <div v-for="(item, i) in data" :key="i" class="offer_container">
                            <img :src="item.imageUrl" />
                            <div class="description_block">
                                <p class="city_name">{{ item.cityName }}</p>
                                <p class="country_name">{{ item.counrtyName }}</p>
                                <!--<p class="sale_offer">from <strong>$2207.00 *</strong></p>-->
                                <!--<a href="#" class="book_now">Book now</a>-->
                            </div>
                        </div>
                    </VueSlickCarousel>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
/* eslint-disable */
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'CheapFlights',
    data() {
        return {
            data: [
                {
                    cityName: 'Moscow',
                    imageUrl: require('../../../assets/images/CheapFlights/pexels-pixabay-417430.png'),
                    counrtyName: 'Rusia',
                },
                {
                    cityName: 'Moscow',
                    imageUrl: require('../../../assets/images/CheapFlights/pexels-pixabay-417430.png'),
                    counrtyName: 'Rusia',
                },
                {
                    cityName: 'Moscow',
                    imageUrl: require('../../../assets/images/CheapFlights/pexels-pixabay-417430.png'),
                    counrtyName: 'Rusia',
                },
                {
                    cityName: 'Moscow',
                    imageUrl: require('../../../assets/images/CheapFlights/pexels-pixabay-417430.png'),
                    counrtyName: 'Rusia',
                },
                {
                    cityName: 'Moscow',
                    imageUrl: require('../../../assets/images/CheapFlights/pexels-pixabay-417430.png'),
                    counrtyName: 'Rusia',
                },
            ],
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        centerPadding: '-202',
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        initialSlide: 2,
                        centerPadding: '-168',
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: '-415',
                    },
                },
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: '-344',
                    },
                },
                {
                    breakpoint: 350,
                    settings: {
                        centerPadding: '-300',
                    },
                },
            ],
        }
    },
    components: {
        VueSlickCarousel,
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

.cheap-flights {
    position: relative;
    padding: 40px 0;
    width: 100%;

    .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        max-width: 1250px;

        .title {
            font-family: 'Poppins-Bold', sans-serif;
            font-size: 36px;
            line-height: 55px;
            text-align: center;
        }

        p {
            font-family: 'Poppins-Light', sans-serif;
            font-size: 18px;
            line-height: 27px;
            text-align: center;
            color: $mainTextBlueColor;
        }

        .owl-carousel {
            margin-top: 60px;
            width: 100%;

            >>> .slick-slider {
                button {
                    width: 30px;
                    height: 30px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                    top: 50%;
                    display: block;

                    &:hover,
                    &:active {
                        border: 1px solid $mainTextBlueColor;
                    }
                }

                .slick-prev {
                    left: -40px;
                    bottom: -20px;
                    width: 29px;
                    height: 29px;
                }

                .slick-prev:before {
                    content: '‹';
                    color: $mainTextBlueColor;
                    position: absolute;
                    font-family: 'Poppins-Regular', sans-serif;
                    font-size: 30px;
                    top: 0px;
                    width: 20px;
                    height: 20px;
                    left: 3.5px;

                    &:hover,
                    &:active {
                        border: 1px solid #4d4c4c;
                    }
                }

                .slick-next {
                    right: -40px;
                    width: 29px;
                    height: 29px;
                }

                .slick-next:before {
                    content: '›';
                    color: $mainTextBlueColor;
                    position: absolute;
                    font-family: 'Poppins-Regular', sans-serif;
                    font-size: 30px;
                    top: 0px;
                    width: 20px;
                    height: 20px;
                    right: 2.5px;
                }

                &:hover,
                &:active {
                    :before {
                        color: $mainTextBlueColor;
                    }
                }

                .slick-list {
                    .slick-track {
                        .slick-slide {
                            padding: 0 20px;
                            width: 405px;

                            :nth-child(1) {
                                :active,
                                :focus {
                                    outline: none;
                                }
                            }

                            .offer_container {
                                width: 381px;
                                height: 221px;
                                background: #ffffff 0% 0% no-repeat padding-box;
                                box-shadow: 0px 3px 15px #0000000f;
                                border-radius: 12px;
                                opacity: 1;
                                display: flex !important;
                                justify-content: space-between;

                                img {
                                    width: 194px;
                                    margin: 0;
                                }

                                .description_block {
                                    width: 45%;
                                    padding: 30px 0;
                                    padding-left: 10px;
                                    color: $mainTextBlueColor;

                                    .city_name {
                                        font-family: 'Poppins-Bold', sans-serif;
                                        text-align: left;
                                        font-size: 24px;
                                        line-height: 27px;
                                        letter-spacing: 0;
                                        margin: 0;
                                        padding-bottom: 10px;
                                    }

                                    .country_name {
                                        font-family: 'Poppins-Regular', sans-serif;
                                        text-align: left;
                                        margin: 0;
                                        padding-bottom: 20px;
                                    }

                                    .sale_offer {
                                        font-family: 'Gilroy-Regular', sans-serif;
                                        font-size: 12px;
                                        line-height: 19px;
                                        letter-spacing: 0.48px;
                                        text-align: left;

                                        strong {
                                            font-family: 'Gilroy-Bold', sans-serif;
                                            font-size: 16px;
                                            line-height: 19px;
                                            letter-spacing: 0.64px;
                                        }
                                    }

                                    .book_now {
                                        font-family: 'Gilroy-SemiBold', sans-serif;
                                        font-size: 18px;
                                        line-height: 22px;
                                        letter-spacing: 0.72px;
                                        color: $mainTextBlueColor;

                                        &:hover {
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        .container {
            max-width: 850px;

            .owl-carousel {
                >>> .slick-slider {
                    .slick-list {
                        .slick-track {
                            .slick-slide {
                                padding: 0 20px;
                                width: 405px;
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 992px) {
        .container {
            max-width: 720px;

            .owl-carousel {
                >>> .slick-slider {
                    .slick-list {
                        .slick-track {
                            .slick-slide {
                                padding: 0 20px;
                                width: 335px;

                                .offer_container {
                                    img {
                                        width: 170px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 768px) {
        .container {
            max-width: 450px;

            .owl-carousel {
                >>> .slick-slider {
                    .slick-list {
                        .slick-track {
                            .slick-slide {
                                padding: 0 30px;
                                width: 415px;

                                .offer_container {
                                    img {
                                        width: 194px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 540px) {
        padding-top: 20px;
        .container {
            max-width: 350px;
            padding: 0;

            .title {
                font-size: 28px;
                line-height: 42px;
            }

            p {
                font-size: 13px;
                line-height: 20px;
            }

            .owl-carousel {
                >>> .slick-slider {
                    button {
                        top: 115%;
                    }

                    .slick-prev {
                        left: 40%;
                    }

                    .slick-next {
                        right: 40%;
                    }

                    .slick-list {
                        .slick-track {
                            .slick-slide {
                                padding: 0 10px;
                                width: 344px;
                                height: 163px;

                                .offer_container {
                                    img {
                                        width: 194px;
                                        height: 163px;
                                    }

                                    .description_block {
                                        padding: 10px 0;
                                        padding-left: 10px;
                                        height: 163px;

                                        .city_name {
                                            font-size: 20px;
                                            line-height: 23px;
                                        }

                                        .country_name {
                                            font-size: 15px;
                                            line-height: 23px;
                                            padding-bottom: 20px;
                                        }

                                        .sale_offer {
                                            font-size: 10px;
                                            line-height: 16px;

                                            strong {
                                                font-size: 13px;
                                                line-height: 16px;
                                            }
                                        }

                                        .book_now {
                                            font-size: 15px;
                                            line-height: 18px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 350px) {
        .container {
            max-width: 300px;

            .owl-carousel {
                >>> .slick-slider {
                    button {
                        top: 115%;
                    }

                    .slick-prev {
                        left: 40%;
                    }

                    .slick-next {
                        right: 40%;
                    }

                    .slick-list {
                        .slick-track {
                            .slick-slide {
                                padding: 0 10px;
                                width: 300px;
                                height: 142px;

                                .offer_container {
                                    img {
                                        width: 169px;
                                        height: 142px;
                                    }

                                    .description_block {
                                        padding: 10px 0;
                                        padding-left: 10px;
                                        height: 163px;

                                        .city_name {
                                            font-size: 16px;
                                            line-height: 20px;
                                        }

                                        .country_name {
                                            font-size: 13px;
                                            line-height: 20px;
                                        }

                                        .sale_offer {
                                            font-size: 8px;
                                            line-height: 13px;

                                            strong {
                                                font-size: 10px;
                                                line-height: 13px;
                                            }
                                        }

                                        .book_now {
                                            font-size: 12px;
                                            line-height: 15px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/CheapFlights.vue